export const ROOT = 'StepTwo/channelPublication/userMessage';

export const FETCH_USER_MESSAGE_REQUEST = `${ROOT}/FETCH_USER_MESSAGE_REQUEST`;
export const FETCH_USER_MESSAGE_FAILURE = `${ROOT}/FETCH_USER_MESSAGE_FAILURE`;
export const FETCH_USER_MESSAGE_SUCCESS = `${ROOT}/FETCH_USER_MESSAGE_SUCCESS`;

export const CLOSE_USER_MESSAGE_MODAL = `${ROOT}/CLOSE_USER_MESSAGE_MODAL`;
export const OPEN_USER_MESSAGE_MODAL = `${ROOT}/OPEN_USER_MESSAGE_MODAL`;
